// 登入後要去哪一頁（一般登入、PIN 登入、已登入直接開首頁三處共用）。
// 事件深連結（eqId / id cookie）優先，由呼叫端先判斷。
// 其次是「被擋下的深連結」（2026-10-30）：未登入／token 過期時 AuthGuard 記下原網址，
// 登入後回到原頁（如 plant/...?64=1、?sn=），不再一律落到首頁。

const RETURN_KEY = "air.returnTo";
const RETURN_TTL_MS = 30 * 60 * 1000;

/** AuthGuard 擋下受保護頁時呼叫：記下 pathname+search（不含語系前綴） */
export function rememberReturnPath(location) {
	try {
		const rest = location.pathname.split("/").slice(2).join("/");
		if (!rest) return;
		sessionStorage.setItem(RETURN_KEY, JSON.stringify({ path: `/${rest}${location.search || ""}`, at: Date.now() }));
	} catch {
		// sessionStorage 不可用（隱私模式等）→ 照舊落首頁
	}
}

function consumeReturnPath(languagePath) {
	try {
		const raw = sessionStorage.getItem(RETURN_KEY);
		sessionStorage.removeItem(RETURN_KEY);
		if (!raw) return null;
		const { path, at } = JSON.parse(raw);
		// 只接受站內路徑（"/x"，不可 "//host"），且 30 分鐘內有效
		if (typeof path !== "string" || !/^\/[^/]/.test(path) || Date.now() - at > RETURN_TTL_MS) return null;
		return `${languagePath}${path}`;
	} catch {
		return null;
	}
}

export function landingPath(decodedUser, languagePath) {
	const returnPath = consumeReturnPath(languagePath);
	if (returnPath) return returnPath;
	if (decodedUser.landingPage === "map") {
		const active = decodedUser.customerId ? `&active=${decodedUser.customerId}` : "";
		return `${languagePath}/map-page?mode=map${active}`;
	}
	if (decodedUser.customerId) return `${languagePath}/plant/${decodedUser.customerId}`;
	return `${languagePath}/map-page`;
}
